<template>
<div class="popup" v-show="isShow">
    <div id="appleTips" class="content">
        <div class="title">
            <span>{{$t('language.popup.appleTipsPopup.title')}}</span>
            <div class="icon white-close dialog-close" @click="close()"></div>
        </div>
        <div class="content-body">
            <div class="popup-title-tips">
                <strong>{{$t('language.popup.appleTipsPopup.tipTitle')}}</strong>
                <div>{{$t('language.popup.appleTipsPopup.tip1')}}</div>
                <div>{{$t('language.popup.appleTipsPopup.tip2')}}</div>
            </div>
            <div class="popup-btns">
                <div class="popup-check-btn">
                    <div class="icon-util" @click.stop="check()" :class="isCheck?'check':'nocheck'"></div>
                    <div>{{$t('language.popup.appleTipsPopup.checkTip')}}</div>
                </div>
                <button @click="submitOk()" >
                    <span class="button-tip">{{$t('language.common.ok')}}</span>
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            isShow: false,
            isCheck: false,
            tempCheck: false,
            item: {},
        }
    },
    components: {
    },
    methods: {
        close(){
            this.isShow=false;
            //打开弹窗,临时标记只使用一次
            this.tempCheck = true;
            this.$parent.addCloudDialog(this.item);
            this.tempCheck = false;
        },
        initShow(item) {
            this.isShow = true;
            this.isCheck = false;
            this.item = item;
        },
        submitOk() {
            if(this.isCheck){
                //如果标记需要记录不再提示，则发送请求
                commonUtils.saveActiveTagByUser(this,"appleTipsCheck",true);
            }
            this.close();
        },
        check() {
            this.isCheck = !this.isCheck;
        }
    }
}
</script>
<style scoped>
#appleTips {
    width: 500Px;
    height: fit-content;
    font-family: Arial;
    font-size: 14Px;
}

#appleTips .content-body {
    display: flex;
    flex-direction: column;
}

.popup-title-tips {
    font-size: 14Px;
    font-weight: 400;
    line-height: 21Px;
    color: #000000;
    margin: 19Px;
}

.popup-title-tips div{
    margin-top: 10Px;
}

#appleTips button {
    min-width: 110Px;
    float: right;
    position: absolute;
    bottom: 20Px;
    right: 20Px;
}

#appleTips button .button-tip {
    margin: 0 10Px;
}

#appleTips .popup-check-btn {
    float: left;
    position: absolute;
    bottom: 25Px;
    left: 20Px;
    display: flex;
}

#appleTips .popup-check-btn .icon-util{  
    margin-right: 5px;
    cursor: pointer;
}

#appleTips .popup-btns {
    height: 70Px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/apple_tips_popup.vue